import React from 'react';
import { FormattedMessage } from 'react-intl';

import Box, { BoxProps } from 'carbon-react/lib/components/box';
import Typography from 'carbon-react/lib/components/typography/typography.component';

export const WizardRequiredFieldInfo = (props?: BoxProps) => {
  return (
    <Box {...props}>
      <Typography fontSize="12px">
        <FormattedMessage
          id="predict.required_field_indication"
          defaultMessage="{asterisk} indicates a required field"
          values={{
            asterisk: <span style={{ color: '#cb374aff', fontSize: '12px', fontWeight: '500' }}>{'*'}</span>
          }}
        />
      </Typography>
    </Box>
  );
};
